import type { LlmAdapter } from "../types.js";

export const ADAPTER_NAMES = ["claude", "openai", "gemini", "cursor"] as const;
export type AdapterName = (typeof ADAPTER_NAMES)[number];

export interface AdapterOptions {
  apiKey?: string;
  model?: string;
}

export async function createLlmAdapter(
  name: string,
  options: AdapterOptions = {},
): Promise<LlmAdapter> {
  switch (name) {
    case "claude": {
      const { ClaudeAdapter } = await import("./claude.js");
      return new ClaudeAdapter(options);
    }
    case "openai": {
      const { OpenAIAdapter } = await import("./openai.js");
      return new OpenAIAdapter(options);
    }
    case "gemini": {
      const { GeminiAdapter } = await import("./gemini.js");
      return new GeminiAdapter(options);
    }
    case "cursor": {
      const { CursorAdapter } = await import("./cursor.js");
      return new CursorAdapter(options);
    }
    default:
      throw new Error(
        `Unknown adapter: ${name}. Available: ${ADAPTER_NAMES.join(", ")}`,
      );
  }
}
